import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuckyCellsService } from '@libs/app.services/landing/lucky-cells.service';
import { IconComponent } from '@libs/stand-alone-components/commons/icon/icon.component';
import { TranslateModule } from '@ngx-translate/core';
import { MillisecondsRemainingPipe } from '@libs/pipes/miliseconds.remaining.pipe';
import { StoreSettingService } from '@libs/app.services/store/store-setting.service';
@Component({
  selector: 'app-lucky-cells-pulsar',
  imports: [CommonModule, IconComponent, TranslateModule, MillisecondsRemainingPipe],
  templateUrl: './lucky-cells-pulsar.component.html',
  styleUrl: './lucky-cells-pulsar.component.scss',
})
export class LuckyCellsPulsarComponent {
  opened = signal<boolean>(false);
  constructor(
    public service: LuckyCellsService,
    private settingService: StoreSettingService,
  ) {}
  openGame() {
    this.settingService.setOverlayLuckyCells(true);
    this.opened.set(false);
  }
  toggle() {
    this.opened.update(v => !v);
  }
}
